import { ReactElement } from 'react';
import { ContentLabelField, TextField } from '@hopskipdrive/react-components';

import { IncidentTripAccount } from '../../../types/incidents';
import { StyledAccount, StyledAccountField } from '../IncidentForm.styles';

interface AccountFieldProps {
  defaultValue?: IncidentTripAccount;
}

export const AccountFieldStatic = ({ defaultValue }: AccountFieldProps): ReactElement => {
  return (
    <ContentLabelField
      id="account"
      title="Account"
      editMode={true}
      required={true}
      editView={
        <StyledAccountField>
          <TextField fullWidth variant={'outlined'} disabled={true} value={defaultValue?.name} />
          <StyledAccount variant="body2" className={defaultValue?.type} />
        </StyledAccountField>
      }
    />
  );
};
